var _templateObject;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { CardInner, showAnimation } from '../commons';
var StyledOptions = styled.div.withConfig({
  displayName: "Options__StyledOptions",
  componentId: "sc-fa0b4h-0"
})(["display:", ";position:absolute;z-index:2;width:fit-content;margin-top:6px;user-select:none;> div > div{padding-right:20px;}", " ", " ", " */ ", ";", ""], function (_ref) {
  var open = _ref.open,
    display = _ref.display;
  return open ? display : 'none';
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: 180px;\n    \n    > div > div {\n      padding-right: 40px;\n    }\n  "]))), function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical && 'transform: rotate(90deg) translate(-120px, 110px);';
}, function (_ref3) {
  var vertical = _ref3.vertical;
  return !vertical && 'translate(0, 480px);';
}, showAnimation, function (_ref4) {
  var position = _ref4.position;
  return position === 'right' ? 'right: 0;' : '';
});
export var Options = function Options(props) {
  var _props$vertical = props.vertical,
    vertical = _props$vertical === void 0 ? false : _props$vertical,
    _props$posX = props.posX,
    posX = _props$posX === void 0 ? 'right' : _props$posX,
    _props$position = props.position,
    position = _props$position === void 0 ? 'left' : _props$position,
    _props$display = props.display,
    display = _props$display === void 0 ? 'block' : _props$display,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant;
  return React.createElement(StyledOptions, {
    vertical: vertical,
    open: props.open,
    position: position,
    display: display,
    variant: variant
  }, React.createElement(CardInner, {
    vertical: vertical,
    posX: posX,
    posY: position,
    arrowPos: 0,
    type: "entity"
  }, props.options.map(function (option, key) {
    return React.createElement(Option, {
      key: key,
      id: option.id,
      label: option.label,
      onClick: function onClick(_ref5) {
        var id = _ref5.id,
          label = _ref5.label;
        props.onChange({
          id: id,
          label: label
        });
      }
    });
  })));
};
var StyledOption = styled.div.withConfig({
  displayName: "Options__StyledOption",
  componentId: "sc-fa0b4h-1"
})(["padding:7px 9px;cursor:pointer;font-size:14px;+ div{border-top:1px solid ", ";}&:hover{background-color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.uiL;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.uiLL;
});
export var Option = function Option(props) {
  return React.createElement(StyledOption, {
    onClick: function onClick() {
      return props.onClick({
        id: props.id,
        label: props.label
      });
    }
  }, props.label);
};